import { useState, useEffect } from 'react';
import axios from 'axios';
import config from './../../config';

export default function useFooterData() {
  const [conditions, setConditions] = useState([]);
  const [footerData, setFooterData] = useState([]);

  const apiUrl = config.REACT_APP_API_URL || process.env.REACT_APP_API_URL;

  // Récupérer toutes les pages sauf celle avec le titre "## a propos"
  const getAllMenu = async () => {
    try {
      const response = await axios.get(`${apiUrl}/page`,{
            headers: { 
            'x-api-key': config.SITE_API_KEY
           }});
      const filteredData = Array.isArray(response?.data)
        ? response.data.filter((page) => page.title !== '## a propos')
        : [];
      setConditions(filteredData);
    } catch (error) {
      console.error('Erreur lors de la récupération des pages:', error.message);
      setConditions([]);
    }
  };

  // Charger les données au montage du composant
  useEffect(() => {
    getAllMenu();
  }, []);

  // Mettre à jour les données du footer lorsque les conditions changent
  useEffect(() => {
    setFooterData([
      {
        title: 'Termes et conditions',
        submenu: conditions.map((cond) => ({
          title: cond?.title?.startsWith('## ')
            ? cond.title.substring(3)
            : cond?.title || 'Condition',
          link: `/condition/${cond?._id}`,
        })),
      },
      {
        title: 'Contactez-nous :',
        submenu: [
          {
            icon: {
              class: "line-icon-Map2"
            },
            title: (
      <>
        Adresse :
        <br />
        163, Av H.Bourguiba. 4021 Kalaa Esseghira Sousse,Tunisie.
      </>
    ),
            link: '/'
          },
          {
            icon: {
              class: "line-icon-Phone-2"
            },
            title: (
      <>
        Telephone :
        <br />
        (+216) 73 298 855
      </>
    ),
            link: '/'
          },
          {
            icon: {
              class: "line-icon-Mail-Read text-basecolor"
            },
            title: (
      <>
        Email :
        <br />
        secretariat@speedtunisia.com
      </>
    ),
            link: '/'
          },
        ],
      },
    ]);
  }, [conditions]);

  return footerData;
}